import type { FunctionComponent } from 'react';

import { BusinessClassIcon } from '@trello/nachos/icons/business-class';

import styles from './PresentationalUpgradePill.less';

export const PresentationalUpgradePill: FunctionComponent = () => {
  return (
    <div className={styles.upgradePromptPill}>
      <BusinessClassIcon
        dangerous_className={styles.upgradePromptPillIcon}
        size="small"
      />
      Upgrade
    </div>
  );
};
